import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import WebIcon from "@mui/icons-material/Web";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaymentsIcon from "@mui/icons-material/Payments";
import ForumIcon from "@mui/icons-material/Forum";
import VideocamIcon from "@mui/icons-material/Videocam";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import { styles } from "./styles";

const FEATURES = [
  {
    Icon: WebIcon,
    title: "Hosted Course Pages",
    description:
      "Polished public pages for every course you offer, published and hosted for you, no website work required.",
  },
  {
    Icon: GroupAddIcon,
    title: "Guided Onboarding",
    description:
      "Bring instructors and students onto the platform with smooth, guided onboarding flows.",
  },
  {
    Icon: DashboardIcon,
    title: "Dashboards for Every Role",
    description:
      "Purpose-built dashboards for your organization, your instructors, and your students.",
  },
  {
    Icon: CalendarMonthIcon,
    title: "Scheduling",
    description:
      "Plan cohorts, set class times, and keep every calendar in sync. No spreadsheets required.",
  },
  {
    Icon: PaymentsIcon,
    title: "Payments",
    description:
      "Collect payments and handle instructor payouts with secure, built-in processing.",
  },
  {
    Icon: ForumIcon,
    title: "Messaging",
    description:
      "Keep your whole community in the loop with messaging built into the platform.",
  },
  {
    Icon: VideocamIcon,
    title: "Video Conferencing",
    description:
      "Run live classes right in the browser. No third-party links to juggle.",
  },
  {
    Icon: FolderSharedIcon,
    title: "File Storage",
    description:
      "Share syllabi, materials, and assignments in one organized place.",
  },
];

const FeaturesSection = () => {
  return (
    <Box sx={styles.section} id="platform-features">
      <Container maxWidth="lg">
        <Typography component="h2" sx={styles.sectionTitle}>
          Everything you need to run live courses
        </Typography>
        <Typography sx={styles.sectionSubtitle}>
          Stop stitching together six different tools. Vulcan covers the full
          journey from course page to live classroom.
        </Typography>
        <Grid container spacing={3} mt={4}>
          {FEATURES.map(({ Icon, title, description }) => (
            <Grid key={title} xs={12} sm={6} lg={3}>
              <Box sx={styles.featureCard}>
                <Box sx={styles.featureIconCircle}>
                  <Icon />
                </Box>
                <Typography sx={styles.featureTitle}>{title}</Typography>
                <Typography sx={styles.featureDescription}>
                  {description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
